(() => {
  const setOptimizedCartCTA = () => {
    const STYLE_ID = "optimized-cart-cta-littletrouble-style";

    const injectCoverageButtonStyles = (shadowRoot) => {
      if (shadowRoot.getElementById(STYLE_ID)) return;

      const style = document.createElement("style");
      style.id = STYLE_ID;
      style.textContent = `
        [data-target="coverage-button"] {
          background-color: var(--scheme-buttons-background) !important;
          --scheme-icons-color: var(--scheme-buttons-label) !important;
          border: 2px solid var(--scheme-buttons-border) !important;
          -webkit-transition: all var(--animation-speed-fast) ease-out !important;
          -moz-transition: all var(--animation-speed-fast) ease-out !important;
          -o-transition: all var(--animation-speed-fast) ease-out !important;
          -ms-transition: all var(--animation-speed-fast) ease-out !important;
          transition: all var(--animation-speed-fast) ease-out !important;
          backdrop-filter: blur(10px) !important;
        }

        [data-target="coverage-button"]:hover {
          background-color: var(--scheme-buttons-background-hover) !important;
          filter: none !important;
        }

        [data-target="coverage-button"]:disabled {
          opacity: 1 !important;
        }

        [data-target='headline-text-container'] {
          color: var(--scheme-buttons-label) !important;
        }

        [data-target="coverage-button"]:hover [data-target='headline-text-container'] {
          color: #FFFFFF !important;
        }
      `;
      shadowRoot.appendChild(style);
    };

    const tryInjectStyles = () => {
      const host = document.querySelector("redo-shopify-toggle");
      if (!host || !host.shadowRoot) return false;

      const btn = host.shadowRoot.querySelector('[data-target="coverage-button"]');
      if (!btn) return false;

      injectCoverageButtonStyles(host.shadowRoot);
      return true;
    };

    // Intento inmediato, por si el widget ya está montado
    if (tryInjectStyles()) return;

    // Si no existe aún, espera a que Redo lo monte
    const observer = new MutationObserver(() => {
      if (tryInjectStyles()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  setOptimizedCartCTA();
})();